import React, { ReactNode, useState } from 'react';
import Icon, { Icons } from '@/components/elements/Icon';

export const Traits = ({
  name,
  itemCount,
  selectedCount,
  refinementList,
}: {
  name: string;
  itemCount: number;
  selectedCount: number;
  refinementList: ReactNode;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-md text-sm">
      <button
        className="py-3 px-4 bg-transparent border-none flex justify-between w-full outline-none text-left"
        onClick={() => setOpen((x) => !x)}
      >
        <h4 className="font-medium mr-4 capitalize">
          {name}
          <span className="ml-1">{`(${
            itemCount >= 100 ? '100+' : itemCount
          })`}</span>
        </h4>
        {selectedCount ? (
          <span className="ml-auto mr-2 text-pink-500">{`(${selectedCount})`}</span>
        ) : null}
        <Icon
          name={Icons.CHEVRON_DOWN}
          className={`transform-gpu text-gray-500 ${
            open ? 'rotate-180' : ''
          } transition-transform`}
          size={16}
        />
      </button>
      <div className={`px-4 pb-4 ${open ? 'block' : 'hidden'}`}>
        {refinementList}
      </div>
    </div>
  );
};

export default Traits;
